<template>
  <div>
    <br />
    <div v-if="loaded">
      <stats :overview="overview" />
      <b-card no-body>
        <b-tabs card content-class="mt-2" justified>
          <b-tab active>
            <b-row align-v="end">
              <b-col cols="5">
                Data filter start:
                <b-form-datepicker
                  id="example-datepicker"
                  v-model="timeFilterStart"
                  :max="timeFilterEnd"
                  value-as-date
                  class="mb-2"
                />
              </b-col>
              <b-col cols="5">
                Data filter end:
                <b-form-datepicker
                  id="example-datepickera"
                  v-model="timeFilterEnd"
                  :min="timeFilterStart"
                  :max="new Date()"
                  value-as-date
                  class="mb-2"
                />
              </b-col>
              <b-col cols="2">
                <b-button
                  variant="primary"
                  id="refreshBtn"
                  @click="refreshStats"
                >
                  <span class="fa fa-refresh" /> Get Latest
                </b-button>
                <b-button
                  variant="primary"
                  v-on:click="exportData"
                  :disabled="!metricsLoaded"
                  class="btn-block"
                  id="exportBtn"
                >
                  <span class="fa fa-download" /> Export Data
                </b-button>
              </b-col>
            </b-row>
            <template v-slot:title> <b-icon-graph-up /> Analytics </template>
            <div v-if="metricsLoaded">
              <b-card-text>
                <b-card-group columns>
                  <b-card no-body>
                    <b-card-title>Traffic trend</b-card-title>
                    <b-card-sub-title>
                      Total/unique views per day
                    </b-card-sub-title>
                    <b-card-body>
                      <chart :chartdata="traffic" />
                    </b-card-body>
                  </b-card>

                  <b-card no-body>
                    <b-card-title>Clones</b-card-title>
                    <b-card-sub-title>
                      Total/unique clone requests per day
                    </b-card-sub-title>
                    <b-card-body>
                      <chart :chartdata="clone" />
                    </b-card-body>
                  </b-card>

                  <b-card no-body>
                    <b-card-title>Popularity</b-card-title>
                    <b-card-sub-title>
                      Fork activity and number of watchers
                    </b-card-sub-title>
                    <b-card-body>
                      <compiled-chart :chartdata="combinedMetrics" />
                    </b-card-body>
                  </b-card>
                </b-card-group>
                <section>
                  <b-card>
                    <b-card-title>Referrers</b-card-title>
                    <b-card-sub-title>
                      The top referrers over the selected time span.
                    </b-card-sub-title>
                    <b-card-text>
                      <div>
                        <b-row>
                          <referrer-chart
                            id="referrerChart"
                            :referrerData="referrer"
                          />
                        </b-row>
                      </div>
                    </b-card-text>
                  </b-card>
                </section>
                <paths :pathData="path" />
              </b-card-text>
            </div>
            <div v-else>
              <div class="text-center">
                <b-spinner
                  variant="primary"
                  class="m-5"
                  label="Loading..."
                ></b-spinner>
              </div>
            </div>
          </b-tab>

          <b-tab>
            <template v-slot:title> <b-icon-clipboard /> Compliance </template>
            <div>
              <h3><i class="fa fa-cog" aria-hidden="true"></i> Settings</h3>
              <ComplianceSettings
                :settings="settings"
                :updateSettings="updateSettings"
                :deleteSettings="exception ? deleteSettings : null"
              />
              <b-row align-h="between" no-gutters id="historyHeader">
                <h3>
                  <i class="fa fa-history" aria-hidden="true"></i> History
                </h3>
                <b-col md="auto">
                  <b-button variant="primary" @click="checkNow">
                    Check Now
                  </b-button>
                </b-col>
              </b-row>
              <ComplianceHistory
                :complianceData="compliance"
                :checkNow="checkNow"
                :loadMore="loadMore"
              />
            </div>
          </b-tab>
          <b-tab>
            <template v-slot:title> <b-icon-pencil /> Admin Info </template>
            <ExtraInfo
              v-if="extraInfo"
              :extraInfo="extraInfo"
              :updateInfo="updateExtraInfo"
            />
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
    <div v-else>
      <div class="text-center">
        <b-spinner variant="primary" class="m-5" label="Loading..."></b-spinner>
      </div>
    </div>
  </div>
</template>

<script>
let models = require("../common/custom_utils.js");

import Stats from "../components/Stats.vue";
import ReferrerChart from "../components/ReferrerChart.vue";
import Paths from "../components/Paths.vue";
import Chart from "../components/Chart.vue";
import CompiledChart from "../components/CompiledChart.vue";
import ComplianceSettings from "../components/ComplianceSettings.vue";
import ComplianceHistory from "../components/ComplianceHistory.vue";
import ExtraInfo from "../components/ExtraInfo.vue";
import { createRepoMetricsCSVBlob, saveFile } from "../common/export_utils";

export default {
  name: "Repo",

  data() {
    return {
      overview: {},
      metrics: [],
      referrer: [],
      path: [],
      traffic: [],
      clone: [],
      combinedMetrics: [],
      loaded: false,
      settings: null,
      exception: false,
      compliance: null,
      extraInfo: null,
      timeFilterStart: new Date(),
      timeFilterEnd: new Date(),
      metricsLoaded: false,
      orgId: -1,
      repoId: -1,
      errorResponse: null,
    };
  },
  components: {
    Stats,
    ReferrerChart,
    Paths,
    Chart,
    CompiledChart,
    ComplianceSettings,
    ComplianceHistory,
    ExtraInfo,
  },
  watch: {
    // call again the method if the route changes
    $route: "Repo",
    timeFilterStart: "getRepoStats",
    timeFilterEnd: "getRepoStats",
  },
  created() {
    // Sets timeFilterStart to be 1 month before todays date
    this.timeFilterStart.setMonth(this.timeFilterStart.getMonth() - 1);
  },
  methods: {
    async getComplianceSettings() {
      let settingsPromise = this.$client
        .get("complianceSettings/REPO/" + this.repoId)
        .then((resp) => {
          this.exception = true;
          return resp;
        })
        .catch(() => {
          return this.$client.get("complianceSettings/ORG/" + this.orgId);
        })
        .catch((error) => {
          console.log("No compliance settings found for repo or org. ", error);
        });

      this.settings = await settingsPromise;
    },
    async getRepoOverview() {
      if (this.orgId && this.repoId) {
        this.overview = await this.$client.get(
          "organizations/" + this.orgId + "/repository/" + this.repoId
        );
      }
    },
    async getRepoStats() {
      this.metricsLoaded = false;
      try {
        if (this.orgId && this.repoId) {
          let copyStart = new Date(this.timeFilterStart);
          let copyEnd = new Date(this.timeFilterEnd);
          copyStart.setHours(0, 0, 0, 0);
          copyEnd.setHours(23, 59, 59, 999);
          this.metrics = await this.$client.get("repositories/" + this.repoId, {
            parameters: {
              startTime: copyStart.toISOString(),
              endTime: copyEnd.toISOString(),
            },
          });

          const metricsJSON = JSON.parse(JSON.stringify(this.metrics));
          this.traffic = await models.trafficArrayOfMaps(metricsJSON);
          this.clone = await models.cloneArrayOfMaps(metricsJSON);
          this.combinedMetrics = await models.combinedArrayOfMaps(metricsJSON);
          this.referrer = await models.referrerArrayOfMaps(metricsJSON);
          this.path = await models.pathArrayOfMaps(metricsJSON);
        } else {
          this.metrics = [];
          this.path = [];
          this.referrer = [];
          this.traffic = [];
          this.clone = [];
          this.combinedMetrics = [];
        }
      } catch (error) {
        console.error(error);
      }
      this.metricsLoaded = true;
    },
    async updateSettings() {
      this.$client.put("complianceSettings/REPO/" + this.repoId, this.settings);
      this.exception = true;
    },
    async deleteSettings() {
      await this.$client.delete("complianceSettings/REPO/" + this.repoId);

      this.exception = false;
      this.getComplianceSettings();
    },
    async getComplianceChecks() {
      try {
      this.compliance = await this.$client.get("complianceInfo/" + this.repoId);
      } catch (err) {
        console.log("no compliance found for repo ", this.repoId)
        this.compliance = null
      }
    },
    async refreshStats() {
      await this.$client.get(
        "check/organization/" + this.orgId + "/repository/" + this.repoId
      );
      this.getRepoStats();
      this.getRepoOverview();
    },
    async checkNow() {
      await this.$client.get(
        "compliance/org/" + this.orgId + "/repo/" + this.repoId
      );
      this.getComplianceChecks();
    },
    async loadMore() {
      var lastTime = this.compliance[this.compliance.length - 1].timeStamp;
      this.compliance.concat(
        await this.$client.get("complianceInfo/" + this.repoId + "/" + lastTime)
      );
    },
    async getExtraInfo() {
      this.extraInfo = await this.$client.get("extraInfo/repo/" + this.repoId);
    },
    async updateExtraInfo(newInfo) {
      try {
        newInfo.repoid = Number(this.repoId)
        newInfo.orgid = Number(this.orgId)
        await this.$client.put("extraInfo/repo/" + this.repoId, newInfo);
        this.extraInfo = newInfo;
      } 
      catch (error) {
        // Handle the error and display the JSON response
        if (error.status && error.status == 403) {
          console.error(`Error`, error.status);
          this.errorResponse = "You are unauthorized to perform this action.";
          this.showErrorResponse();
          if (error.data) {
            console.error("Additional info:", error.data)
          }
        } else {
          console.error("Error:", error.message);
        }
      }
    },
    showErrorResponse() {
      this.$bvModal
        .msgBoxOk(this.errorResponse, {
          title: "Alert",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true,
        })
        .then((value) => {
          console.log(value);
          location.reload();
        });
    },
    exportData() {
      saveFile(
        this.overview.name,
        createRepoMetricsCSVBlob(this.overview.name, this.metrics)
      );
    },
  },
  mounted() {
    //initialize org and repo ids to be used in API calls
    this.orgId = this.$route.params.orgid;
    this.repoId = this.$route.params.repoid;

    Promise.all([
      this.getRepoOverview(),
      this.getRepoStats(),
      this.getComplianceSettings(),
      this.getComplianceChecks(),
      this.getExtraInfo(),
    ]).finally(() => (this.loaded = true));
  },
};
</script>

<style lang="scss">
#historyHeader {
  margin: 30px 0 10px 0;
}
#refreshBtn {
  margin-bottom: 5px;
  float: right;
  width: 100%;
}
#exportBtn {
  margin-bottom: 0.5rem;
}
#dataControlContainer {
  padding-bottom: 15px;
}
#referrerChart {
  width: 100%;
}
</style>
